import { connect } from 'react-redux';
import ManagerPendingList from "./ManagerPendingList";
import { bindActionCreators } from 'redux';
import { updateCampaignData, getCampaignData } from 'services/redux/brandActivtion/adsCampaign/action';

const mapStateToProps = state => ({
    getCampaignListing: state.campaignReducer.getCampaignListing,
    updateStatusForCampaign: state.campaignReducer.updateStatusForCampaign
});

const mapDispatchToProps = dispatch => bindActionCreators({
    updateCampaignData,
    getCampaignData
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(ManagerPendingList);
